import { Length, postpartumOption } from "~/OnboardingApp/utils";

export const getDueDateCopyKeys = (lengthOfTimeTtc: Length | undefined) => {
  if (lengthOfTimeTtc === postpartumOption) {
    return {
      description: "onboarding.dueDatePage.postpartumDescription",
      question: "onboarding.dueDatePage.postpartumQuestion",
    } as const;
  }

  return {
    description: "onboarding.dueDatePage.description",
    question: "onboarding.dueDatePage.question",
  } as const;
};
